import { ChangeEvent } from 'react';

import TextLimit from '@atom/components/common/TextLimit';
import { TextField } from '@atom/mui';
import {
  MAX_CHAR_DESCRIPTION,
  MAX_CHAR_SHORT_INPUT,
  REVEAL_LONG,
} from '@atom/selectors/formSelectors';

import classes from '../formBuilder.module.css';

interface Props {
  title: string;
  description: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const BasicInput = ({ title, description, onChange }: Props) => {
  return (
    <div className={classes.multiInputContainer}>
      <div className={classes.doubleInput}>
        <TextField
          variant="standard"
          value={title}
          onChange={onChange}
          name="title"
          label="Title"
        />
        <div className={classes.textLimitContainer}>
          <TextLimit
            limit={MAX_CHAR_SHORT_INPUT}
            reveal={REVEAL_LONG}
            text={title}
          />
        </div>
      </div>
      <div className={classes.doubleInput}>
        <TextField
          variant="standard"
          value={description}
          onChange={onChange}
          name="description"
          label="Description"
        />
        <div className={classes.textLimitContainer}>
          <TextLimit
            limit={MAX_CHAR_DESCRIPTION}
            reveal={REVEAL_LONG}
            text={description}
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInput;
